module.exports = __webpack_public_path__ + "img/dc3370e.jpg";